/* PhonePartPro — client-side faceted filter (Compatible Brand → Model → Part Type).
   Built because Shopify native tag/path filtering is disabled on this store.
   Works on collection and search results pages: reads product data attrs off grid items,
   auto-loads all paginated pages, builds multi-select checkboxes, filters client-side. */
(function () {
  'use strict';

  var BRANDS = ['Apple', 'Samsung', 'Google', 'Motorola', 'OnePlus', 'LG', 'Huawei', 'HTC', 'TCL', 'Nokia', 'Sony', 'Fitbit'];
  var BRAND_LC = BRANDS.map(function (b) { return b.toLowerCase(); });
  var NOISE = /pack|tempered|glass|\boem\b|uv |zerocycle|zero cycle|premium|choice|refurb|adhesive|protector|series glass|cold press|\boca\b|lcd|battery|flex|housing|digitizer|charger|cable|tool|apex/i;
  var MODEL_KW = /(iphone|ipad|ipod|galaxy|note|pixel|moto|oneplus|nord|nexus|watch|gear|revvl|stylo|thinq|honor|mate)/i;

  var grid = document.getElementById('product-grid');
  var mount = document.getElementById('ppp-facets-mount');
  if (!grid || !mount) return;
  // The element that actually holds .grid__item children (collections: #product-grid IS the ul;
  // search: #product-grid is a div containing the ul).
  var gridList = grid.tagName === 'UL' ? grid : (grid.querySelector('ul.grid, ul.product-grid, ul') || grid);

  var state = { brands: [], models: [], types: [], loadedAll: false, loading: false };

  function items() { return Array.prototype.slice.call(gridList.querySelectorAll('.grid__item')); }
  function parse(li) {
    return {
      li: li,
      tags: (li.getAttribute('data-ppp-tags') || '').split('|').filter(Boolean),
      type: (li.getAttribute('data-ppp-type') || '').trim()
    };
  }
  function modelBrand(tl) {
    if (/galaxy|note|gear/.test(tl)) return 'Samsung';
    if (/iphone|ipad|ipod|apple watch|watch series/.test(tl)) return 'Apple';
    if (/pixel|nexus/.test(tl)) return 'Google';
    if (/moto|revvl/.test(tl)) return 'Motorola';
    if (/oneplus|nord/.test(tl)) return 'OnePlus';
    if (/thinq|stylo/.test(tl)) return 'LG';
    return 'Other';
  }

  /* ---- load every paginated page so filtering is complete ---- */
  function nextPageUrl(doc) {
    var pager = (doc || document).querySelector('.pagination-wrapper');
    if (!pager) return null;
    var cur = parseInt(pager.getAttribute('data-page') || '1', 10) || 1;
    var links = pager.querySelectorAll('a.pagination__item[href]');
    for (var i = 0; i < links.length; i++) {
      var m = /[?&]page=(\d+)/.exec(links[i].getAttribute('href') || '');
      if (m && parseInt(m[1], 10) === cur + 1) return links[i].getAttribute('href');
    }
    return null;
  }
  var MAX_PAGES = 25; // safety cap so a huge result set can't runaway
  function loadAll(cb) {
    if (state.loadedAll) { cb(); return; }
    var url = nextPageUrl(document);
    if (!url) { state.loadedAll = true; cb(); return; }
    state.loading = true;
    setBusy(true);
    var pages = 0;
    var finish = function () { state.loadedAll = true; state.loading = false; setBusy(false); cb(); };
    var step = function (u) {
      if (++pages > MAX_PAGES) { finish(); return; }
      fetch(u, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (newGrid) {
            newGrid.querySelectorAll('.grid__item').forEach(function (li) { gridList.appendChild(li); });
          }
          var pager = document.querySelector('.pagination-wrapper');
          if (pager) pager.style.display = 'none';
          var nu = nextPageUrl(doc);
          if (nu) { setTimeout(function () { step(nu); }, 120); } else { finish(); }
        })
        .catch(function () { finish(); });
    };
    step(url);
  }
  function setBusy(b) {
    mount.classList.toggle('ppp-facets--busy', b);
  }

  /* ---- build facet lists from loaded products ---- */
  function classify() {
    var brands = {}, models = {}, types = {};
    items().forEach(function (li) {
      var d = parse(li);
      if (d.type) types[d.type] = (types[d.type] || 0) + 1;
      d.tags.forEach(function (t) {
        var tl = t.toLowerCase();
        if (BRAND_LC.indexOf(tl) >= 0) { brands[t] = true; }
        else if (MODEL_KW.test(tl) && !NOISE.test(tl)) {
          var b = modelBrand(tl);
          (models[b] = models[b] || {})[t] = true;
        }
      });
    });
    return { brands: Object.keys(brands).sort(), models: models, types: types };
  }

  var ACRONYMS = {lcd:'LCD',oled:'OLED',oem:'OEM',sim:'SIM',ic:'IC',fpc:'FPC',uv:'UV',usb:'USB',nfc:'NFC','5g':'5G',lte:'LTE',tft:'TFT',id:'ID',oca:'OCA',led:'LED',ir:'IR',lg:'LG',htc:'HTC',zte:'ZTE',tcl:'TCL',asus:'ASUS',xr:'XR',xs:'XS',se:'SE',uw:'UW',nfc:'NFC'};
  function titleCase(s){
    return String(s).split(/(\s+|\/)/).map(function(w){
      var lw = w.toLowerCase();
      if (ACRONYMS[lw]) return ACRONYMS[lw];
      if (w === lw && /[a-z]/.test(w)) return w.charAt(0).toUpperCase() + w.slice(1); // only ALL-lowercase words
      return w;                                                                        // keep iPhone / iPad / mixed
    }).join('');
  }
  function chip(group, value, label, brandData) {
    var id = 'pppf-' + group + '-' + value.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
    var l = document.createElement('label');
    l.className = 'ppp-facet-opt';
    if (brandData) l.setAttribute('data-brand', brandData);
    l.innerHTML = '<input type="checkbox" value="' + value.replace(/"/g, '&quot;') + '" data-group="' + group + '" id="' + id + '">' +
      '<span class="ppp-facet-box"></span><span class="ppp-facet-txt">' + label + '</span>';
    return l;
  }

  function build() {
    var c = classify();
    mount.innerHTML = '';

    var head = document.createElement('div');
    head.className = 'ppp-facets__head';
    head.innerHTML = '<span class="ppp-facets__title">Filter</span><span class="ppp-facets__count"></span><button type="button" class="ppp-facets__clear" hidden>Clear all</button>';
    mount.appendChild(head);

    // Part Type
    var typeKeys = Object.keys(c.types).sort();
    if (typeKeys.length) {
      var g1 = groupEl('Part Type');
      typeKeys.forEach(function (t) { g1.list.appendChild(chip('type', t, titleCase(t) + ' <em>' + c.types[t] + '</em>')); });
      mount.appendChild(g1.el);
    }

    // Compatible Brand
    if (c.brands.length) {
      var g2 = groupEl('Compatible Brand');
      c.brands.forEach(function (b) { g2.list.appendChild(chip('brand', b, titleCase(b))); });
      mount.appendChild(g2.el);
    }

    // Compatible Model (cascades: hidden until a brand is chosen)
    var modelBrands = Object.keys(c.models);
    if (modelBrands.length) {
      var g3 = groupEl('Compatible Model');
      g3.el.classList.add('ppp-facet-group--models');
      var hint = document.createElement('p');
      hint.className = 'ppp-facet-modelhint';
      hint.textContent = 'Select a brand to see models';
      g3.el.insertBefore(hint, g3.list);
      var search = document.createElement('input');
      search.type = 'text'; search.className = 'ppp-facet-search'; search.placeholder = 'Search model…';
      search.setAttribute('aria-label', 'Search model');
      g3.el.insertBefore(search, g3.list);
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase();
        g3.list.querySelectorAll('.ppp-facet-opt').forEach(function (o) {
          if (o.style.display === 'none') return; // respect brand cascade
          o.dataset._h = (o.textContent.toLowerCase().indexOf(q) < 0) ? '1' : '';
          o.style.visibility = o.dataset._h ? 'hidden' : '';
          o.style.position = o.dataset._h ? 'absolute' : '';
        });
      });
      modelBrands.sort().forEach(function (b) {
        Object.keys(c.models[b]).sort().forEach(function (m) {
          var opt = chip('model', m, titleCase(m), b);
          opt.style.display = 'none';
          g3.list.appendChild(opt);
        });
      });
      mount.appendChild(g3.el);
    }

    mount.addEventListener('change', onChange);
    head.querySelector('.ppp-facets__clear').addEventListener('click', clearAll);
  }

  function groupEl(title) {
    var el = document.createElement('details');
    el.className = 'ppp-facet-group';
    el.open = true;
    var sum = document.createElement('summary');
    sum.className = 'ppp-facet-legend';
    sum.textContent = title;
    el.appendChild(sum);
    var list = document.createElement('div');
    list.className = 'ppp-facet-list';
    el.appendChild(list);
    return { el: el, list: list };
  }

  function selected(group) {
    return Array.prototype.slice.call(mount.querySelectorAll('input[data-group="' + group + '"]:checked'))
      .map(function (i) { return i.value.toLowerCase(); });
  }

  function onChange(e) {
    if (!e.target.matches('input[type="checkbox"]')) return;
    if (e.target.getAttribute('data-group') === 'brand') cascadeModels();
    applyFilter();
    narrowOptions();
    updateClear();
  }

  function cascadeModels() {
    var brands = selected('brand'); // lowercased
    var group = mount.querySelector('.ppp-facet-group--models');
    if (!group) return;
    var hint = group.querySelector('.ppp-facet-modelhint');
    var any = brands.length > 0;
    if (hint) hint.style.display = any ? 'none' : '';
    group.querySelectorAll('.ppp-facet-opt').forEach(function (o) {
      var b = (o.getAttribute('data-brand') || '').toLowerCase();
      var show = any && brands.indexOf(b) >= 0;
      o.style.display = show ? '' : 'none';
      if (!show) { var cb = o.querySelector('input'); if (cb.checked) cb.checked = false; }
    });
  }

  function narrowOptions() {
    var sel = { type: selected('type'), brand: selected('brand'), model: selected('model') };
    var prods = items().map(function (li) { var d = parse(li); return { type: (d.type || '').toLowerCase(), tags: d.tags.map(function (t) { return t.toLowerCase(); }) }; });
    function ok(p, exclude) {
      if (exclude !== 'type'  && sel.type.length  && sel.type.indexOf(p.type) < 0) return false;
      if (exclude !== 'brand' && sel.brand.length && !sel.brand.some(function (b) { return p.tags.indexOf(b) >= 0; })) return false;
      if (exclude !== 'model' && sel.model.length && !sel.model.some(function (m) { return p.tags.indexOf(m) >= 0; })) return false;
      return true;
    }
    ['type', 'brand'].forEach(function (g) {
      mount.querySelectorAll('input[data-group="' + g + '"]').forEach(function (cb) {
        var opt = cb.closest('.ppp-facet-opt'), v = cb.value.toLowerCase();
        if (cb.checked) { opt.classList.remove('ppp-facet-opt--empty'); return; }   // keep chosen ones
        var has = prods.some(function (p) {
          if (g === 'type'  && p.type !== v) return false;
          if (g === 'brand' && p.tags.indexOf(v) < 0) return false;
          return ok(p, g);
        });
        opt.classList.toggle('ppp-facet-opt--empty', !has);                          // only show values that still match
      });
    });
  }
  function applyFilter() {
    var types = selected('type'), brands = selected('brand'), models = selected('model');
    var shown = 0;
    items().forEach(function (li) {
      var d = parse(li);
      var tagsLc = d.tags.map(function (t) { return t.toLowerCase(); });
      var okType = !types.length || types.indexOf(d.type.toLowerCase()) >= 0;
      var okBrand = !brands.length || brands.some(function (b) { return tagsLc.indexOf(b) >= 0; });
      var okModel = !models.length || models.some(function (m) { return tagsLc.indexOf(m) >= 0; });
      var show = okType && okBrand && okModel;
      li.style.display = show ? '' : 'none';
      if (show) shown++;
    });
    updateCount(shown);
  }

  function updateCount(n) {
    var el = document.querySelector('.ppp-facets__count');
    if (el) el.textContent = n + (n === 1 ? ' product' : ' products');
  }
  function updateClear() {
    var any = mount.querySelectorAll('input:checked').length > 0;
    var btn = mount.querySelector('.ppp-facets__clear');
    if (btn) btn.hidden = !any;
  }
  function clearAll() {
    mount.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; });
    cascadeModels(); applyFilter(); narrowOptions(); updateClear();
  }

  /* Build facets after all products are loaded (so every option is present). */
  function init() {
    setBusy(true);
    loadAll(function () {
      build();
      applyFilter();
      setBusy(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
